import React from "react";
import { useState } from "@wordpress/element";
import { SocialIcons } from "../AddSVGS";
const Person = ({
  person,
  displayCity,
  displayDesignation,
  displayEmail,
  displayFeaturedImage,
  displayName,
  displayHomeLink,
  displayPhone,
  displayProfileLink,
  displayRankNumber,
  displaySocialLink,
  displayTitle,
  rank_info,
  displayVaralla,
  selectedValue,
}) => {
  const featuredImage =
    person._embedded &&
    person._embedded["wp:featuredmedia"] &&
    person._embedded["wp:featuredmedia"].length > 0 &&
    person._embedded["wp:featuredmedia"][0];
  const [rows, setRows] = useState([{ 0: "", 1: "", 2: "", 3: "" }]);
  return (
    <React.Fragment key={person.id}>
      <div
        className={`arcloud-people-column col-${selectedValue || "12"} ${
          selectedValue === "4" || selectedValue === "3"
            ? "vertical"
            : "horizontal"
        }`}
        key={person.id}
        style={{
          order:
            Array.from({
              length: Math.max(rows.length, Object.keys(rank_info).length),
            })
              .map(
                (_, index) =>
                  rank_info[index] &&
                  rank_info[index][2] == person.id &&
                  rank_info[index][0]
              )
              .find((value) => value !== false) || 1000000,
        }}
      >
        <div
          className={`artcloud-peoples-item ${person.id}`}
          data-id={`${person.id}`}
        >
          <div className="artcloud-row-child">
            {displayFeaturedImage &&
              featuredImage &&
              featuredImage.media_details &&
              featuredImage.media_details.sizes &&
              featuredImage.media_details.sizes.thumbnail && (
                <div className="col-4 imageArea">
                  <div className="artcloud-peoples-image">
                    <img
                      src={featuredImage.source_url}
                      alt={featuredImage.alt_text}
                    />
                  </div>
                </div>
              )}
            <div className="col-4 contentArea">
              <div className="artcloud-peoples-content">
                <a
                  href={displayProfileLink && (person.link ? person.link : "#")}
                >
                  <h5>
                    {displayName && person.title && person.title.rendered}
                  </h5>
                </a>

                {displayDesignation && (
                  <p>
                    {Array.from({
                      length: Math.max(
                        rows.length,
                        Object.keys(rank_info).length
                      ),
                    }).map(
                      (_, index) =>
                        rank_info[index] &&
                        rank_info[index][2] == person.id &&
                        rank_info[index][1]
                    )}
                  </p>
                )}
                {displayTitle && (
                  <p className="people_title">
                    {person.person_meta_fields.people_title}
                  </p>
                )}
                {displayCity && (
                  <p className="people_city">
                    {person.person_meta_fields.people_city}
                  </p>
                )}
                {displayPhone && (
                  <p className="people_phone">
                    {person.person_meta_fields.people_phone}
                  </p>
                )}
                {displayEmail && (
                  <p className="people_email">
                    {person.person_meta_fields.people_email}
                  </p>
                )}
                <div className="social-link">
                  {displayHomeLink && (
                    <a
                      className="people_home"
                      href={`https://${person.person_meta_fields.home}`}
                    >
                      {SocialIcons.homesocial}
                    </a>
                  )}
                  {displaySocialLink && (
                    <>
                      <a
                        className="people_twitter"
                        href={`https://${person.person_meta_fields.twitter}`}
                      >
                        {SocialIcons.twitter}
                      </a>
                      <a
                        className="people_facebook"
                        href={`https://${person.person_meta_fields.facebook}`}
                      >
                        {SocialIcons.facebook}
                      </a>
                      <a
                        className="people_linkedin"
                        href={`https://${person.person_meta_fields.linkedin}`}
                      >
                        {SocialIcons.linkedin}
                      </a>
                      <a
                        className="people_instagram"
                        href={`https://${person.person_meta_fields.instagram}`}
                      >
                        {SocialIcons.instagram}
                      </a>
                    </>
                  )}
                </div>
                {displayVaralla &&
                  Array.from({
                    length: Math.max(
                      rows.length,
                      Object.keys(rank_info).length
                    ),
                  }).map((_, index) => {
                    if (rank_info[index] && rank_info[index][2] == person.id) {
                      const personTitle =
                        wp.data
                          .select("core")
                          .getEntityRecord(
                            "postType",
                            "person",
                            rank_info[index][3]
                          )?.title?.rendered || "";
                      const personEmail =
                        wp.data
                          .select("core")
                          .getEntityRecord(
                            "postType",
                            "person",
                            rank_info[index][3]
                          )?.person_meta_fields?.people_email || "";
                      if (personTitle && personEmail != "") {
                        return (
                          <div key={index} className="artcloud-peoples-varalla">
                            <h6>Varalla</h6>
                            <p className="varalla-title">{personTitle}</p>
                            <p className="varalla-email">{personEmail}</p>
                          </div>
                        );
                      }
                    }
                    return null; // Ensure .map() always returns something
                  })}
              </div>
            </div>
            <div className="col-4">
              {displayRankNumber && person.person_meta_fields.rank_number && (
                <h6 className="people_rank">
                  {person.person_meta_fields.rank_number}
                </h6>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Person;
